import React from "react";
import { useTranslation } from "react-i18next";
import { TypeSpecificFieldsProps } from "./types";
import { useFieldChoices } from "./useFieldChoices";

const MotorFields: React.FC<TypeSpecificFieldsProps> = ({ data, onChange }) => {
  const { t } = useTranslation(['insurance', 'common']);
  const set = (key: string, value: any) => onChange({ ...data, [key]: value });

  const vehicleTypes = useFieldChoices("motor", "vehicle_type");
  const coverTypes = useFieldChoices("motor", "motor_cover_type");

  return (
    <div className="irf-grid">
      <div className="irf-field">
        <label>{t('insurance:motor.vehicleType')}</label>
        <select
          value={data.vehicle_type || ""}
          onChange={(e) => set("vehicle_type", e.target.value)}
        >
          <option value="">{t('insurance:motor.selectVehicleType')}</option>
          {vehicleTypes.map((tp) => (
            <option key={tp.value} value={tp.value}>{tp.label}</option>
          ))}
        </select>
      </div>
      <div className="irf-field">
        <label>{t('insurance:motor.coverType')}</label>
        <select
          value={data.motor_cover_type || ""}
          onChange={(e) => set("motor_cover_type", e.target.value)}
        >
          <option value="">{t('insurance:motor.selectCoverType')}</option>
          {coverTypes.map((tp) => (
            <option key={tp.value} value={tp.value}>{tp.label}</option>
          ))}
        </select>
      </div>
      <div className="irf-field">
        <label>{t('insurance:motor.registrationNumber')}</label>
        <input
          value={data.registration_number || ""}
          onChange={(e) => set("registration_number", e.target.value)}
          placeholder={t('insurance:motor.registrationNumberPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:motor.engineNumber')}</label>
        <input
          value={data.engine_number || ""}
          onChange={(e) => set("engine_number", e.target.value)}
          placeholder={t('insurance:motor.engineNumberPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:motor.chassisNumber')}</label>
        <input
          value={data.chassis_number || ""}
          onChange={(e) => set("chassis_number", e.target.value)}
          placeholder={t('insurance:motor.chassisNumberPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:motor.idv')}</label>
        <input
          type="number"
          value={data.idv ?? ""}
          onChange={(e) => set("idv", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:motor.idvPlaceholder')}
        />
      </div>
      <div className="irf-field">
        <label>{t('insurance:motor.ncbPercentage')}</label>
        <input
          type="number"
          value={data.ncb_percentage ?? ""}
          onChange={(e) => set("ncb_percentage", e.target.value ? Number(e.target.value) : "")}
          placeholder={t('insurance:motor.ncbPercentagePlaceholder')}
        />
      </div>
    </div>
  );
};

export default MotorFields;
